import { defineComponent as _defineComponent } from 'vue'
import MemberItem from '../ManageMember/MemberItem';
import Dialog from '../common/base/Dialog';
import useIndex from './useIndexHooks';
import { storeToRefs } from 'pinia';
import { useRoomStore } from '../../stores/room';
import SvgIcon from '../common/base/SvgIcon.vue';
import ApplyTipsIcon from '../common/icons/ApplyTipsIcon.vue';
import { USERS_STATUS } from '../../constants/room';


export default /*#__PURE__*/_defineComponent({
  __name: 'indexH5',
  setup(__props) {

const roomStore = useRoomStore();
const {
  applyToAnchorList,
  isMicrophoneDisableForAllUser,
  isCameraDisableForAllUser,
  isGeneralUser,
} = storeToRefs(roomStore);

const {
  audioManageInfo,
  videoManageInfo,
  showManageAllUserDialog,
  dialogTitle,
  dialogContent,
  ManageControlType,
  toggleManageAllMember,
  doToggleManageAllMember,
  t,
  handleToggleStaged,
  applyToAnchorUserContent,
  showApplyUserList,
  showMoreControl,
  moreControlList,
  toggleClickMoreBtn,
  userStatusList,
  currentActiveTabName,
  filteredUserStatusList,
  handleCallAllInvitee,
} = useIndex();

return { __sfc: true,roomStore, applyToAnchorList, isMicrophoneDisableForAllUser, isCameraDisableForAllUser, isGeneralUser, audioManageInfo, videoManageInfo, showManageAllUserDialog, dialogTitle, dialogContent, ManageControlType, toggleManageAllMember, doToggleManageAllMember, t, handleToggleStaged, applyToAnchorUserContent, showApplyUserList, showMoreControl, moreControlList, toggleClickMoreBtn, userStatusList, currentActiveTabName, filteredUserStatusList, handleCallAllInvitee, MemberItem, Dialog, SvgIcon, ApplyTipsIcon, USERS_STATUS }
}

})